import { render, staticRenderFns } from "./confirmTransfer.popup-chunk.vue?vue&type=template&id=7dec7ce2&scoped=true"
import script from "./confirmTransfer.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./confirmTransfer.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./confirmTransfer.popup-chunk.vue?vue&type=style&index=0&id=7dec7ce2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dec7ce2",
  null
  
)

export default component.exports